import * as React from 'react';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

const excelReports = [
    {
        name: "Месячный отчет",
        urlName: "monthReportExcel"
    },
    {
        name: "Отчет за календарный месяц",
        urlName: "monthCalendarReport"
    }
]

export function ReportMenu(props) {
    const { selectCallback } = props;
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = (reportName) => {
        setAnchorEl(null);
        if (excelReports.find(report => report.urlName === reportName))
            selectCallback(reportName);
    };

    return (
        <div>
            <Button
                id="basic-button"
                aria-controls={open ? 'basic-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}
            >
                Скачать отчет
            </Button>
            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                slotProps={{
                    list: {
                        'aria-labelledby': 'basic-button',
                    },
                }}
            >
                {
                    excelReports.map(report =>
                        <MenuItem onClick={() => handleClose(report.urlName)} key={report.urlName}>{report.name}</MenuItem>
                    )
                }
            </Menu>
        </div>
    );
}
